export const GET_NOTIFICATIONS = '[Notification Action] Get Notifications';
export const CONFIRMED_GET_NOTIFICATIONS = '[Notification Action] Confirmed Get Notifications';
export const CLEAR_ALL_NOTIFICATIONS = '[Notification Action] Clear All Notifications';